/* eslint-disable max-len */
import React from 'react';
import Icon from './Icon';

export default Icon(
  <g>
    <g>
      <g>
        <path d="M8.3,0c0.4,0.1,0.7,0.2,1,0.5c0.5,0.4,0.7,1,0.8,1.7c0,0.1,0,0.2,0,0.3c0.1,0,0.1,0,0.2,0c0.7,0,1.5,0,2.2,0c0.5,0,0.7,0.2,0.7,0.7c0,0.2,0,0.3,0,0.5c0.2,0,0.4,0,0.6,0c0,0.4,0,0.8,0,1.2c-0.4,0-0.8,0-1.2,0c0,0.1,0,0.1,0,0.2c0,3,0,6,0,8.9c0,0.8-0.4,1.4-1.1,1.7c-0.2,0.1-0.5,0.2-0.8,0.2c-2.5,0-4.9,0-7.4,0c-1,0-1.8-0.8-1.8-1.9c0-3,0-6,0-8.9c0-0.1,0-0.1,0-0.2c-0.4,0-0.8,0-1.2,0c0-0.4,0-0.8,0-1.2c0.2,0,0.4,0,0.6,0c0-0.2,0-0.4,0-0.5c0-0.5,0.2-0.7,0.7-0.7c0.7,0,1.4,0,2.2,0c0.1,0,0.1,0,0.2,0c0-0.2,0-0.4,0-0.6c0.1-1,0.8-1.6,1.7-1.9c0,0,0,0,0.1,0C6.6,0,7.4,0,8.3,0z M2.7,4.9c0,0.1,0,0.1,0,0.2c0,3,0,6,0,8.9c0,0.5,0.2,0.7,0.7,0.7c2.4,0,4.8,0,7.2,0c0.5,0,0.7-0.2,0.7-0.7c0-3,0-6,0-8.9c0-0.1,0-0.1,0-0.2C8.4,4.9,5.6,4.9,2.7,4.9z M8.8,2.5c0-0.1,0-0.2,0-0.2c0-0.6-0.4-1-1-1s-1.1,0-1.7,0S5,1.8,5.2,2.5C6.4,2.5,7.6,2.5,8.8,2.5z" />
      </g>
      <g>
        <path d="M7.6,13.5c-0.4,0-0.8,0-1.2,0c0-2.5,0-4.9,0-7.4c0.4,0,0.8,0,1.2,0C7.6,8.6,7.6,11.1,7.6,13.5z" />
      </g>
      <g>
        <path d="M5.1,13.5c-0.4,0-0.8,0-1.2,0c0-2.5,0-4.9,0-7.4c0.4,0,0.8,0,1.2,0C5.1,8.6,5.1,11.1,5.1,13.5z" />
      </g>
      <g>
        <path d="M10.1,13.5c-0.4,0-0.8,0-1.2,0c0-2.5,0-4.9,0-7.4c0.4,0,0.8,0,1.2,0C10.1,8.6,10.1,11.1,10.1,13.5z" />
      </g>
    </g>
  </g>,
  '0 0 14 16',
  'TrashIcon',
);
